import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { AspDashboardComponent } from './asp-dashboard.component';import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
// import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { FuseSharedModule } from '@fuse/shared.module';
import { ApplicationPipesModule } from 'app/main/applicationPipesModule.module';
import { HttpClient, HttpClientModule } from '@angular/common/http';

import { FlexLayoutModule } from '@angular/flex-layout';
import { MatTabsModule } from '@angular/material/tabs';

const routes: Routes = [
  {
      path: 'garage-dashboard',
      component: AspDashboardComponent,
  },
];

@NgModule({
  declarations: [AspDashboardComponent],
  imports: [ RouterModule.forChild(routes),
    CommonModule,
    FuseSharedModule,
    MatCardModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatProgressBarModule,
    ApplicationPipesModule,
    HttpClientModule,
    FlexLayoutModule,
    MatTabsModule,
  ],
  exports: [AspDashboardComponent],
})
export class AspDashboardModule { }
